/**
 * Footer action bar for the medical PA form: save/continue buttons, the
 * optional medical-necessity toggle (RPA/NCH workflows), and a back button.
 *
 * @module medicalPaForm/components/medicalPaFormFooter
 */
import { Button } from "@risalabs_frontend_org/oasis-ui-kit";
import { Footer } from "risa-oasis-ui_v2";
import { QuestionnaireStatus } from "../../../enums/questionnaireStatus";
import { MedicalPaFormFooterProps } from "../types";
import ToggleForMedicalNeccessity from "./toggleForMedicalNeccessity";

/**
 * Renders the sticky footer with Save / Continue actions and workflow-specific
 * extras.
 *
 * @param props - See {@link MedicalPaFormFooterProps}.
 * @returns The footer element.
 */
const MedicalPaFormFooter = ({
  isSaving,
  loading,
  isAllFieldsValidationFree,
  isLoading,
  submissionType,
  hasQuestions,
  questionnaireStatus,
  onSave,
  onSubmit,
  onToggleMedicalNeccessity,
  onGoBack,
}: MedicalPaFormFooterProps) => {
  return (
    <div className="medical-pharma-pa-form__footer">
      <Footer
        cancelButtonText={isSaving ? "Saving..." : "Save"}
        isDisabled={
          loading || !isAllFieldsValidationFree || isLoading || isSaving
        }
        submitButtonText={loading ? "Continuing..." : "Continue"}
        onCancelClick={onSave}
        isCancelDisabled={loading || isSaving}
        onSubmitClick={onSubmit}
        children={
          <>
            {submissionType === "rpa_nch" && (
              <ToggleForMedicalNeccessity
                onToggle={onToggleMedicalNeccessity}
                disabled={
                  !hasQuestions ||
                  questionnaireStatus === QuestionnaireStatus.IN_PROGRESS
                }
              />
            )}
            <Button
              children="Go Back"
              onClick={onGoBack}
              buttonType="tertiary"
              size="medium"
              disabled={false}
            />
          </>
        }
      />
    </div>
  );
};

export default MedicalPaFormFooter;
